import { Component, OnInit } from '@angular/core';
import { TranslateService } from "../../../common/variables/translate-service";

@Component({
  selector: 'sen-app-print-offer',
  templateUrl: './print-offer.component.html',
  styleUrls: ['./print-offer.component.scss']
})
export class PrintOfferComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
